(function () {
  if (document.documentElement.dataset.mainProductClickBound !== 'true') {
    document.documentElement.dataset.mainProductClickBound = 'true';
    document.addEventListener('click', function (e) {
      if (e.target.closest('quick-add-modal')) {
        return;
      }

      if (e.target.closest('.product-description-more')) {
        e.preventDefault();
        const short = e.target.closest('.product-description-short');
        if (short) {
          const full = short.nextElementSibling;
          if (full && full.classList.contains('product-description-full')) full.style.display = '';
          short.style.display = 'none';
        }
      }

      if (e.target.closest('.product-description-less')) {
        e.preventDefault();
        const full = e.target.closest('.product-description-full');
        if (full) {
          const short = full.previousElementSibling;
          if (short && short.classList.contains('product-description-short')) short.style.display = '';
          full.style.display = 'none';
        }
      }

      if (e.target.closest('.js-show-more')) {
        e.preventDefault();
        const btn = e.target.closest('.js-show-more');
        btn.parentElement.querySelectorAll('input.hidden, label.hidden').forEach(el => el.classList.remove('hidden'));
        btn.remove();
      }
    });
  }
})();

(function () {
  const productSection = document.querySelector('[data-recently-product-id]');
  if (!productSection) return;

  const STORAGE_KEY = '__sf_theme_recently';
  const productId = productSection.dataset.recentlyProductId;
  const expirationDays = productSection.dataset.recentlyExpirationDays
    ? Number(productSection.dataset.recentlyExpirationDays)
    : 30;
  const dateNow = Date.now();

  let recentProducts;
  try {
    recentProducts = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  } catch (error) {
    recentProducts = [];
  }

  const expirationTime = expirationDays * 24 * 60 * 60 * 1000;
  recentProducts = recentProducts.filter((item) => dateNow - item.timestamp < expirationTime);

  const existingIndex = recentProducts.findIndex((item) => item.productId == productId);
  if (existingIndex !== -1) {
    recentProducts[existingIndex].timestamp = dateNow;
  } else {
    recentProducts.unshift({ productId, timestamp: dateNow });
  }

  recentProducts.sort((a, b) => b.timestamp - a.timestamp);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(recentProducts));
})();

/* Second floated product form */
if (!customElements.get("floated-form")) {
  class FloatedForm extends HTMLElement {
    constructor() {
      super();
      this.renderForm();
    }

    async renderForm() {
      const response = await fetch(this.getAttribute("data-product-url"));
      const responseText = await response.text();
      const responseHTML = new DOMParser().parseFromString(
        responseText,
        "text/html"
      );
      this.productElement = responseHTML.querySelector(
        'div[id^="ProductInfo-"]'
      );
      if (!this.productElement) return;

      this.preventDuplicatedIDs();
      this.removeDOMElements();
      this.setInnerHTML(this, this.productElement.innerHTML);

      if (window.Shopify && Shopify.PaymentButton) {
        Shopify.PaymentButton.init();
      }

      if (window.ProductModel) window.ProductModel.loadShopifyXR();
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;
    }

    preventDuplicatedIDs() {
      const sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(
        sectionId,
        `floated-${sectionId}`
      );

      if (this.productElement.querySelectorAll("variant-selects")) {
        this.productElement
          .querySelectorAll("variant-selects")
          .forEach((radio) => {
            radio.dataset.originalSection = sectionId;
          });
      }

      if (this.productElement.querySelectorAll("variant-radios")) {
        this.productElement
          .querySelectorAll("variant-radios")
          .forEach((radio) => {
            radio.dataset.originalSection = sectionId;
          });
      }
    }

    removeDOMElements() {
      const text = this.productElement.querySelector(".product__text");
      if (text) text.remove();

      const shareButtons = this.productElement.querySelector(".share-buttons");
      if (shareButtons) shareButtons.remove();

      const rating = this.productElement.querySelector(".rating");
      if (rating) rating.remove();

      const tags = this.productElement.querySelector(".product-tags");
      if (tags) tags.remove();

      const description = this.productElement.querySelector(
        ".product__description"
      );
      if (description) description.remove();

      const advantages = this.productElement.querySelectorAll(".advantage");
      advantages.forEach((advantage) => {
        advantage.remove();
      });

      const note = this.productElement.querySelector(".note");
      if (note) note.remove();

      const promoBanner = this.productElement.querySelector(".promo-banner");
      if (promoBanner) promoBanner.remove();

      const pickupAvailability = this.productElement.querySelector(
        "pickup-availability"
      );
      if (pickupAvailability) pickupAvailability.remove();

      const productModal = this.productElement.querySelector("product-modal");
      if (productModal) productModal.remove();

      const productForm = this.productElement.querySelector("floated-form");
      if (productForm) productForm.remove();

      const relatedProduct =
        this.productElement.querySelector("related-product");
      if (relatedProduct) relatedProduct.remove();

      const gift = this.productElement.querySelector(".customer");
      if (gift) gift.remove();

      const customLiquid = this.productElement.querySelector(".custom-liquid");
      if (customLiquid) customLiquid.remove();
    }
  }

  customElements.define("floated-form", FloatedForm);
}
